import React from "react";
import WifiOffIcon from "@mui/icons-material/WifiOff"; // Using an MUI icon

export const NoInternetPage = () => {
  const handleRetry = () => {
    // Attempt to reload the previous page or navigate home
    // Check if online first before navigating away
    if (navigator.onLine) {
      window.history.back(); // Go back to the previous page if possible
      // Or navigate('/'); // Or redirect to the home page
    } else {
      // Optionally, provide feedback that there's still no connection
      alert("Still no internet connection detected.");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
        fontFamily: "sans-serif",
        color: "#5f6368",
      }}
    >
      <WifiOffIcon
        style={{ fontSize: 100, marginBottom: 20, color: "#5f6368" }}
      />
      <h1 style={{ fontSize: "24px", margin: "0 0 10px 0" }}>No Internet</h1>
      <p style={{ fontSize: "16px", marginBottom: 5 }}>Try:</p>
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: "0 0 20px 0",
          fontSize: "14px",
        }}
      >
        <li>Checking the network cables, modem, and router</li>
        <li>Reconnecting to Wi-Fi</li>
      </ul>
      <p style={{ fontSize: "12px", marginBottom: 20 }}>
        ERR_INTERNET_DISCONNECTED
      </p>
      <button
        onClick={handleRetry}
        style={{
          padding: "10px 20px",
          fontSize: "14px",
          color: "#fff",
          backgroundColor: "#1a73e8",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Retry
      </button>
    </div>
  );
};
